import ELCBTreeViewModel from "../modelTreeViews/ELCBTreeviewModel";
import BaseModel from "./BaseModel";
import BaseModelMap from "./BaseModelMap";
import BaseObject from "./BaseObject";

import { copyAllProperties } from "./utils";

import Logger from "../Logger";

const logger = new Logger();
//////////////////////////////////////////////////
import ObjectFactory from "./ObjectFactory";
import Fuse from "./Fuse";
import Cabinet from "./Cabinet";
import type { DeviceCabinetPlacement } from "./DeviceCabinetPlacement";

ObjectFactory.registerClass("ELCB", (data?: any, parent?: BaseModel) => {
  return new ELCB({});
});
//////////////////////////////////////////////////
export default class ELCB extends BaseModel {
  public get className(): string {
    return "ELCB"; // no itx
  }

  getParentCollectionName(): string | undefined {
    return "elcbs"; // no itx
  }
  fuses = new BaseModelMap<Fuse>(Fuse, this, "f");

  // -----------------------------------------------------------------------------
  // cabinetPlacement
  // -----------------------------------------------------------------------------
  _cabinetPlacement?: DeviceCabinetPlacement;
  get cabinetPlacement(): DeviceCabinetPlacement | undefined {
    return this._cabinetPlacement;
  }

  set cabinetPlacement(newValue: DeviceCabinetPlacement | undefined) {
    if (this._cabinetPlacement === newValue) return;
    this.beforeChange("cabinetPlacement");
    this._cabinetPlacement = newValue;
    this.changed("cabinetPlacement");
  }

  // -----------------------------------------------------------------------------

  getPersistentProperties(): string[] {
    return ["fuses", "cabinetPlacement", ...super.getPersistentProperties()]; // no itx
  }

  emptyTagIsForbidden(): boolean {
    return true;
  }

  canBeEditedInteractive(): boolean {
    return false;
  }
  /////////////////////////////////////////////////////////////////////////////////
  // if the connected channels of this actor are already connected with terminals and or fuses it should not be possible
  // -> to much confusion for user if moving is possible or not
  ///////////
  canBeMovedToNewParent(newParent: BaseModel) {
    return false;
  }

  constructor(data?: any, parent?: BaseObject) {
    super(data, parent);
    copyAllProperties(data, this);
    this.treeViewModel = new ELCBTreeViewModel(this);
  }

  delete(): Array<BaseObject> {
    this.isDeleting = true;

    var res = new Array<BaseObject>();
    res = res.concat(this.fuses.deleteAllItems());

    res = res.concat(super.delete());
    return res;
  }

  getParentChildrenGroup(): Array<BaseModel> | undefined {
    return (this.parent as Cabinet)?.elcbs.sortBy("tag");
  }
  getAllTagsFromSameTypeWithoutOwn(): string[] | undefined {
    const parentCabinet = this.parent as Cabinet;
    if (parentCabinet && !state.projectMetadata.uniqueTagsForProject) {
      const res = new Array<string>();
      parentCabinet.elcbs.forEach((elcb1) => {
        if (this.tag != elcb1.tag) {
          res.push(elcb1.tag);
        }
      });
      return res;
    } else if (state.projectMetadata.uniqueTagsForProject) {
      const res = new Array<string>();
      state.allELCBs().forEach((elcb1) => {
        if (this.tag != elcb1.tag) {
          res.push(elcb1.tag);
        }
      });
      return res;
    }
    return undefined;
  }

  renumber() {
    state.nameAndTagManager.renumberFuseTags(this);
    this.raiseOnChange("childCollection");
  }
}
